import React from 'react'
import {
    darkenColor,
    GRAY_COLOR_HEX,
    isAuthenticated,
    isVideo,
    lightenColor,
    openNotificationInToast
} from '../../../utilities'
import ReactPlayer from 'react-player'
import {Button, Checkbox, ConfigProvider, Image, Input, Radio, Rate, Slider, Space} from 'antd'
import CountUp from 'react-countup'
import {RiCheckboxCircleFill, RiCloseCircleFill} from 'react-icons/ri'
import DrawerBox from '../../../components/common/DrawerBox'
import success from '../../../assets/images/success.json'
import {isMobile} from 'react-device-detect'
import Lottie from 'react-lottie'
import AdvertisementModerator from './AdvertisementModerator'
import {AiFillPushpin, AiOutlineClose} from 'react-icons/ai'
import {
    HappyEmojiIcon,
    HeartEyesEmojiIcon,
    NuetralEmojiIcon,
    SadEmojiIcon,
    SmilingEmojiIcon,
    ThumbsDownEmojiIcon,
    ThumbsUpEmojiIcon
} from "../../../utilities/resources.js";

const {TextArea} = Input

const SINGLE_SELECT = 1
const MULTI_SELECT = 2

export const MCQ = 1
export const OPINIONATED = 2
export const SLIDER = 3
export const LIKE_DISLIKE = 4
export const STAR = 5
export const SMILEY = 6
export const TEXT = 7

const LIKE_OPTION = 1
const DISLIKE_OPTION = 2

const VERY_SAD_OPTION = 1
const SAD_OPTION = 2
const NEUTRAL_OPTION = 3
const HAPPY_OPTION = 4
const VERY_HAPPY_OPTION = 5

export const EMOJI_NUMBER_MAPPING = {
    [VERY_SAD_OPTION]: SadEmojiIcon,
    [SAD_OPTION]: NuetralEmojiIcon,
    [NEUTRAL_OPTION]: HappyEmojiIcon,
    [HAPPY_OPTION]: SmilingEmojiIcon,
    [VERY_HAPPY_OPTION]: HeartEyesEmojiIcon,
}

export const data = {
    mainFontColor: '#000',
    btnColor: '#f02e72',
    hdrColor: '#0081d4',
    hdrBtnFontColor: '#fff',
}

const defaultOptionsSuccess = {
    loop: true,
    autoplay: true,
    animationData: success,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
}

function ModeratorQuestionDrawer({
                                     visible,
                                     setVisible,
                                     questionData,
                                     submitResponseToSocket,
                                     closeText,
                                     isQuestionSubmitted,
                                     showingResult,
                                     questionResult,
                                     selectedData,
                                     setSelectedData,
                                     updateAdClickToSocket,
                                     updateAdViewToSocket,
                                     isAdmin,
                                     sendOutQuestion,
                                 }) {
    const isOptSelected = (optId, checkAnswer) => {
        return showingResult && (checkAnswer ? selectedData.answer == optId : selectedData.selectedOptions && selectedData.selectedOptions.length > 0 && selectedData.selectedOptions.includes(optId))
    }

    const generateSliderArray = (minValue = 1, maxValue = 10, stepper = 1) => {
        const array = []
        for (let i = minValue; i <= maxValue; i += stepper) {
            array.push(i)
        }
        return array
    }

    const getBorderColor = (optId, checkAnswer) => {
        return lightenColor(isOptSelected(optId, checkAnswer) ? data.hdrColor : GRAY_COLOR_HEX, 0.6)
    }

    const getBackgroundColor = (optId, checkAnswer) => {
        return lightenColor(isOptSelected(optId, checkAnswer) ? data.hdrColor : GRAY_COLOR_HEX, 0.8)
    }

    const handleOnChange = (key, value) => {
        setSelectedData({...selectedData, [key]: value})
    }

    const handleSubmitResponse = () => {
        if ((!selectedData.selectedOptions || selectedData.selectedOptions.length == 0) && !selectedData.answer) {
            openNotificationInToast('info', 'No Response Provided!', 'Please fill out this question to submit!')
            return
        }
        let payload = {
            sectionQuestionId: questionData.id,
            selectedOptions: selectedData.selectedOptions,
            answer: selectedData.answer,
            accessToken: isAuthenticated(),
        }
        submitResponseToSocket(payload)
    }

    const handleCloseQuestionModal = () => {
        setVisible()
    }

    const singleResponseOption = () => {
        return (
            <Space direction='vertical' className='quiz-options width-full'>
                <Radio.Group
                    name='options'
                    className='flex fd-column jc-space-between ant-radio-button'
                    value={selectedData.selectedOptions && selectedData.selectedOptions.length > 0 ? selectedData.selectedOptions[0] : null}
                    onChange={(ev) => (showingResult ? {} : handleOnChange('selectedOptions', [ev.target.value]))}
                >
                    {questionData &&
                        questionData.sectionQuestionOptions &&
                        questionData.sectionQuestionOptions.map((opt) => {
                            return (
                                <>
                                    {showingResult ? ( //&& questionData.responseType != MCQ
                                        ''
                                    ) : (
                                        <Radio value={opt.id}>
                                            <div className='flex items-center jc-space-between width-full mt-4'>
                                                <span className='mr-10 font-size-16'>{opt.name}</span>{' '}
                                            </div>
                                        </Radio>
                                    )}
                                    {showingResult ? ( //&& questionData.responseType != MCQ
                                        <>
                                            <div className='poll-bar'
                                                 style={{fontWeight: selectedData.selectedOptions && selectedData.selectedOptions.length > 0 && opt.id == selectedData.selectedOptions[0] ? 700 : ''}}>
                                                <div
                                                    className='poll-progress'
                                                    style={{
                                                        borderColor: getBorderColor(opt.id),
                                                        background: getBackgroundColor(opt.id),
                                                        width: `${questionResult.agg ? questionResult.agg[opt.id] : 0}%`,
                                                    }}
                                                ></div>
                                                <div className='poll-percent'>
                                                    <CountUp start={0}
                                                             end={questionResult.agg && questionResult.agg[opt.id] > 0 ? questionResult.agg[opt.id] : 0}
                                                             duration={1.5}/>%
                                                </div>
                                                <div className='poll-text flex items-center'>
                                                    {opt.name}
                                                    {showingResult && selectedData.selectedOptions && selectedData.selectedOptions.length > 0 ? (
                                                        opt.id == selectedData.selectedOptions[0] && questionResult.correctOption ? (
                                                            opt.id == questionResult.correctOption.id ? (
                                                                <RiCheckboxCircleFill
                                                                    className='ml-10 font-color-green font-size-18'/>
                                                            ) : (
                                                                <RiCloseCircleFill
                                                                    className='ml-10 font-color-red font-size-18'/>
                                                            )
                                                        ) : questionResult.correctOption && opt.id == questionResult.correctOption.id ? (
                                                            <RiCheckboxCircleFill
                                                                className='ml-10 font-color-green font-size-18'/>
                                                        ) : (
                                                            ''
                                                        )
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </>
                            )
                        })}
                    {questionData.allowOthers ? (
                        <>
                            {showingResult ? ( //&& questionData.responseType != MCQ
                                ''
                            ) : (
                                <Radio value={0}>Others (please specify)</Radio>
                            )}
                            {showingResult ? ( //&& questionData.responseType != MCQ
                                <>
                                    <div className='poll-bar'
                                         style={{fontWeight: selectedData.selectedOptions && selectedData.selectedOptions.length > 0 && selectedData.selectedOptions[0] == 0 ? 700 : ''}}>
                                        <div className='poll-progress' style={{
                                            borderColor: getBorderColor(0),
                                            background: getBackgroundColor(0),
                                            width: `${questionResult.agg ? questionResult.agg[0] : 0}%`
                                        }}></div>
                                        <div className='poll-percent'>
                                            <CountUp start={0}
                                                     end={questionResult.agg && questionResult.agg[0] > 0 ? questionResult.agg[0] : 0}
                                                     duration={1.5}/>%
                                        </div>
                                        <div className='poll-text flex items-center'>Others (please specify)</div>
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                        </>
                    ) : (
                        ''
                    )}
                </Radio.Group>
                {selectedData.selectedOptions && selectedData.selectedOptions.includes(0) ? (
                    <TextArea value={selectedData.answer} rows={4} disabled={showingResult}
                              placeholder='Type your answer here...'
                              onChange={(ev) => (showingResult ? {} : handleOnChange('answer', ev.target.value))}
                              className='mt-16'/>
                ) : (
                    ''
                )}
            </Space>
        )
    }

    const multiSelectResponseOption = () => {
        return (
            <Space direction='vertical' className='width-full'>
                <Checkbox.Group className='flex fd-column jc-space-between ant-checkbox-button' name='options'
                                value={selectedData.selectedOptions}
                                onChange={(value) => (showingResult ? {} : handleOnChange('selectedOptions', value))}>
                    {questionData &&
                        questionData.sectionQuestionOptions &&
                        questionData.sectionQuestionOptions.map((opt) => {
                            return (
                                <>
                                    {showingResult && questionResult.agg ? (
                                        ''
                                    ) : (
                                        <Checkbox key={opt.id} value={opt.id}>
                                            {opt.name}
                                        </Checkbox>
                                    )}
                                    {showingResult ? (
                                        <>
                                            <div className='poll-bar'
                                                 style={{fontWeight: selectedData.selectedOptions && selectedData.selectedOptions.length > 0 && selectedData.selectedOptions.includes(opt.id) ? 700 : ''}}>
                                                <div className='poll-progress' style={{
                                                    borderColor: getBorderColor(opt.id),
                                                    background: getBackgroundColor(opt.id),
                                                    width: `${questionResult.agg ? questionResult.agg[opt.id] : 0}%`
                                                }}></div>
                                                <div className='poll-percent'>
                                                    <CountUp start={0}
                                                             end={questionResult.agg && questionResult.agg[opt.id] > 0 ? questionResult.agg[opt.id] : 0}
                                                             duration={1.5}/>%
                                                </div>
                                                <div className='poll-text flex items-center'>{opt.name}</div>
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </>
                            )
                        })}
                    {questionData.allowOthers ? (
                        <>
                            {showingResult && questionResult.agg ? '' :
                                <Checkbox value={0}>Others (please specify)</Checkbox>}
                            {showingResult ? (
                                <>
                                    <div className='poll-bar'
                                         style={{fontWeight: selectedData.selectedOptions && selectedData.selectedOptions.length > 0 && selectedData.selectedOptions.includes(0) ? 700 : ''}}>
                                        <div className='poll-progress' style={{
                                            borderColor: getBorderColor(0),
                                            background: getBackgroundColor(0),
                                            width: `${questionResult.agg ? questionResult.agg[0] : 0}%`
                                        }}></div>
                                        <div className='poll-percent'>
                                            <CountUp start={0}
                                                     end={questionResult.agg && questionResult.agg[0] > 0 ? questionResult.agg[0] : 0}
                                                     duration={1.5}/>%
                                        </div>
                                        <div className='poll-text flex items-center'>Others (please specify)</div>
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                        </>
                    ) : (
                        ''
                    )}
                </Checkbox.Group>
                {selectedData.selectedOptions && selectedData.selectedOptions.includes(0) ? (
                    <TextArea value={selectedData.answer} rows={4} disabled={showingResult}
                              placeholder='Type your answer here...'
                              onChange={(ev) => (showingResult ? {} : handleOnChange('answer', ev.target.value))}
                              className='mt-16'/>
                ) : (
                    ''
                )}
            </Space>
        )
    }

    const sliderResponse = () => {
        return (
            <div>
                <div className='flex fd-row items-center jc-space-between font-size-16 font-bold-700'>
                    <span
                        className={`flex-shrink-0 mr-28 ${showingResult && questionResult.agg ? 'mt-30' : 'mt-5'} default-line font-size-20`}>{questionData.minValue}</span>
                    <Slider
                        className={`flex-grow-1 steps-slider ${showingResult && questionResult.agg ? 'mt-35' : ''}`}
                        handleStyle={{
                            background: lightenColor(data.btnColor, 0.1),
                            border: 'none',
                            height: 20,
                            width: 20
                        }}
                        trackStyle={{background: 'transparent'}}
                        railStyle={{
                            background: `linear-gradient(90deg, ${lightenColor(data.hdrColor, 0.5)} 0%, ${lightenColor(data.hdrColor, 0.1)} 100%)`,
                            height: 10,
                            borderRadius: 5
                        }}
                        value={selectedData.answer}
                        onChange={(value) => (showingResult ? {} : handleOnChange('answer', value))}
                        min={questionData.minValue}
                        max={questionData.maxValue}
                        step={questionData.stepSize}
                    />
                    <span
                        className={`flex-shrink-0 ml-16 ${showingResult && questionResult.agg ? 'mt-30' : 'mt-5'} default-line font-size-20`}>{questionData.maxValue}</span>
                </div>
                {showingResult ? (
                    <div className='mt-16'>
                        {questionData &&
                            generateSliderArray(questionData.minValue, questionData.maxValue, questionData.stepSize).map((item) => {
                                return (
                                    <div className='poll-bar'
                                         style={{fontWeight: isOptSelected(item, true) ? 700 : ''}}>
                                        <div className='poll-progress' style={{
                                            borderColor: getBorderColor(item, true),
                                            background: getBackgroundColor(item, true),
                                            width: `${questionResult.agg ? questionResult.agg[item] : 0}%`
                                        }}></div>
                                        <div className='poll-percent'>
                                            <CountUp start={0}
                                                     end={questionResult.agg && questionResult.agg[item] ? questionResult.agg[item] : 0}
                                                     duration={1.5}/>%
                                        </div>
                                        <div
                                            className='poll-text flex items-center'>{item + (questionData.units ? ' ' + questionData.units : '')}</div>
                                    </div>
                                )
                            })}
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    }

    const likeDislikeResponse = () => {
        return (
            <div className={`flex items-center jc-center ${showingResult ? 'fd-column' : 'fd-row'}`}>
                <div className='flex fd-column jc-space-between items-center flex-grow-1 width-full'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            onClick={() => (showingResult ? {} : handleOnChange('answer', LIKE_OPTION))}
                            style={{
                                border: `1px solid ${selectedData.answer == LIKE_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == LIKE_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                                marginRight: -54,
                            }}
                            className='pt-8 pb-8 pr-16 pl-16 rounded-12 animated flex fd-column items-center jc-center width-74 height-74'
                        >
                            <img src={ThumbsUpEmojiIcon} alt='' className='width-32'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar' style={{fontWeight: isOptSelected(LIKE_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(LIKE_OPTION, true),
                                    background: getBackgroundColor(LIKE_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[LIKE_OPTION] ? questionResult.agg[LIKE_OPTION] : 0}%`
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[LIKE_OPTION] ? questionResult.agg[LIKE_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <img src={ThumbsUpEmojiIcon} alt='' style={{marginTop: 0}}/>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className='flex fd-column jc-space-between items-center flex-grow-1 width-full'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            onClick={() => (showingResult ? {} : handleOnChange('answer', DISLIKE_OPTION))}
                            style={{
                                border: `1px solid ${selectedData.answer == DISLIKE_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == DISLIKE_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                                marginLeft: -54,
                            }}
                            className='pt-8 pb-8 pr-16 pl-16 rounded-12 animated flex fd-column items-center jc-center width-74 height-74'
                        >
                            <img src={ThumbsDownEmojiIcon} alt='' className='width-32'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar mt-24'
                             style={{fontWeight: isOptSelected(DISLIKE_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(DISLIKE_OPTION, true),
                                    background: getBackgroundColor(DISLIKE_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[DISLIKE_OPTION] ? questionResult.agg[DISLIKE_OPTION] : 0}%`,
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[DISLIKE_OPTION] ? questionResult.agg[DISLIKE_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <img src={ThumbsDownEmojiIcon} alt='' style={{marginTop: 0}}/>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        )
    }

    const ratingResponse = () => {
        return (
            <div className='mt-24 text-center'>
                <Rate
                    autoFocus={true}
                    allowClear={false}
                    onChange={(value) => (showingResult ? {} : handleOnChange('answer', value))}
                    value={selectedData.answer ? selectedData.answer : null}
                    className='rate-stars'
                    style={{color: lightenColor(data.btnColor, 0.1), fontSize: 54}}
                />
                {showingResult ? (
                    <div className='mt-16'>
                        {[1, 2, 3, 4, 5].map((item) => {
                            return (
                                <div className='poll-bar' style={{fontWeight: isOptSelected(item, true) ? 700 : ''}}>
                                    <div className='poll-progress' style={{
                                        borderColor: getBorderColor(item, true),
                                        background: getBackgroundColor(item, true),
                                        width: `${questionResult.agg ? questionResult.agg[item] : 0}%`
                                    }}></div>
                                    <div className='poll-percent'>
                                        <CountUp start={0}
                                                 end={questionResult.agg && questionResult.agg[item] ? questionResult.agg[item] : 0}
                                                 duration={1.5}/>%
                                    </div>
                                    <div className='poll-text flex items-center'>
                                        <Rate value={item} style={{color: lightenColor(data.btnColor, 0.1)}}/>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    }

    const smileyResponse = () => {
        return (
            <div className={`font-size-36 flex jc-space-between ${showingResult ? 'fd-column' : 'fd-row'}`}>
                <div className='flex fd-column jc-space-between items-center'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            style={{
                                border: `1px solid ${selectedData.answer == VERY_SAD_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == VERY_SAD_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                            }}
                            className='rounded-12 width-55 height-55 animated flex jc-center items-center font-color-red'
                            onClick={() => (showingResult ? {} : handleOnChange('answer', VERY_SAD_OPTION))}
                        >
                            <img src={SadEmojiIcon} alt='' className='width-30'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar' style={{fontWeight: isOptSelected(VERY_SAD_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(VERY_SAD_OPTION, true),
                                    background: getBackgroundColor(VERY_SAD_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[VERY_SAD_OPTION] ? questionResult.agg[VERY_SAD_OPTION] : 0}%`,
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[VERY_SAD_OPTION] ? questionResult.agg[VERY_SAD_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <div className='font-color-red height-30'
                                     onClick={() => (showingResult ? {} : handleOnChange('answer', VERY_SAD_OPTION))}>
                                    <img src={SadEmojiIcon} alt=''/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className='flex fd-column jc-space-between items-center'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            style={{
                                border: `1px solid ${selectedData.answer == SAD_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == SAD_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                            }}
                            className='rounded-12 width-55 height-55 animated flex jc-center items-center font-color-orange'
                            onClick={() => (showingResult ? {} : handleOnChange('answer', SAD_OPTION))}
                        >
                            <img src={NuetralEmojiIcon} alt='' className='width-30'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar mt-24'
                             style={{fontWeight: isOptSelected(SAD_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(SAD_OPTION, true),
                                    background: getBackgroundColor(SAD_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[SAD_OPTION] ? questionResult.agg[SAD_OPTION] : 0}%`
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[SAD_OPTION] ? questionResult.agg[SAD_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <div className='font-color-orange height-30'
                                     onClick={() => (showingResult ? {} : handleOnChange('answer', SAD_OPTION))}>
                                    <img src={NuetralEmojiIcon} alt=''/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className='flex fd-column jc-space-between items-center'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            style={{
                                border: `1px solid ${selectedData.answer == NEUTRAL_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == NEUTRAL_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                            }}
                            className='rounded-12 width-55 height-55 animated flex jc-center items-center font-color-yellow'
                            onClick={() => (showingResult ? {} : handleOnChange('answer', NEUTRAL_OPTION))}
                        >
                            <img src={HappyEmojiIcon} alt='' className='width-30'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar mt-24'
                             style={{fontWeight: isOptSelected(NEUTRAL_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(NEUTRAL_OPTION, true),
                                    background: getBackgroundColor(NEUTRAL_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[NEUTRAL_OPTION] ? questionResult.agg[NEUTRAL_OPTION] : 0}%`,
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[NEUTRAL_OPTION] ? questionResult.agg[NEUTRAL_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <div className='font-color-yellow height-30'
                                     onClick={() => (showingResult ? {} : handleOnChange('answer', NEUTRAL_OPTION))}>
                                    <img src={HappyEmojiIcon} alt=''/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className='flex fd-column jc-space-between items-center'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            style={{
                                border: `1px solid ${selectedData.answer == HAPPY_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == HAPPY_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                            }}
                            className='rounded-12 width-55 height-55 animated flex jc-center items-center font-color-light-green'
                            onClick={() => (showingResult ? {} : handleOnChange('answer', HAPPY_OPTION))}
                        >
                            <img src={SmilingEmojiIcon} alt='' className='width-30'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar mt-24'
                             style={{fontWeight: isOptSelected(HAPPY_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(HAPPY_OPTION, true),
                                    background: getBackgroundColor(HAPPY_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[HAPPY_OPTION] ? questionResult.agg[HAPPY_OPTION] : 0}%`,
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[HAPPY_OPTION] ? questionResult.agg[HAPPY_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <div className='font-color-light-green height-30'
                                     onClick={() => (showingResult ? {} : handleOnChange('answer', HAPPY_OPTION))}>
                                    <img src={SmilingEmojiIcon} alt=''/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className='flex fd-column jc-space-between items-center'>
                    {showingResult ? (
                        ''
                    ) : (
                        <div
                            style={{
                                border: `1px solid ${selectedData.answer == VERY_HAPPY_OPTION ? darkenColor(data.btnColor, 0.1) : lightenColor(GRAY_COLOR_HEX, 0.2)}`,
                                background: selectedData.answer == VERY_HAPPY_OPTION ? `linear-gradient(180deg, ${lightenColor(data.btnColor, 0.4)} 0%, ${lightenColor(data.hdrColor, 0.4)} 100%)` : '',
                            }}
                            className='rounded-12 width-55 height-55 animated flex jc-center items-center font-color-green'
                            onClick={() => (showingResult ? {} : handleOnChange('answer', VERY_HAPPY_OPTION))}
                        >
                            <img src={HeartEyesEmojiIcon} alt='' className='width-30'/>
                        </div>
                    )}
                    {showingResult ? (
                        <div className='poll-bar mt-24'
                             style={{fontWeight: isOptSelected(VERY_HAPPY_OPTION, true) ? 700 : ''}}>
                            <div
                                className='poll-progress'
                                style={{
                                    borderColor: getBorderColor(VERY_HAPPY_OPTION, true),
                                    background: getBackgroundColor(VERY_HAPPY_OPTION, true),
                                    width: `${questionResult.agg && questionResult.agg[VERY_HAPPY_OPTION] ? questionResult.agg[VERY_HAPPY_OPTION] : 0}%`,
                                }}
                            ></div>
                            <div className='poll-percent'>
                                <CountUp start={0}
                                         end={questionResult.agg && questionResult.agg[VERY_HAPPY_OPTION] ? questionResult.agg[VERY_HAPPY_OPTION] : 0}
                                         duration={1.5}/>%
                            </div>
                            <div className='poll-text flex items-center'>
                                <div className='font-color-green height-30'
                                     onClick={() => (showingResult ? {} : handleOnChange('answer', VERY_HAPPY_OPTION))}>
                                    <img src={HeartEyesEmojiIcon} alt=''/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        )
    }

    const textResponse = () => {
        return <TextArea value={selectedData.answer} rows={4} disabled={showingResult}
                         placeholder='Type your answer here...'
                         onChange={(ev) => (showingResult ? {} : handleOnChange('answer', ev.target.value))}
                         className='mt-16'/>
    }

    return (
        <DrawerBox visible={visible} setVisible={handleCloseQuestionModal} closeIcon={null} maskClosable={false}
                   height={'90vh'} width='450px' placement={isMobile ? 'bottom' : 'right'}
                   headerStyle={{display: 'none'}}>
            <div className='flex fd-column jc-space-between min-height-full'>
                <div>
                    {isQuestionSubmitted ? (
                        <div className='width-full height-full flex fd-column jc-center items-center p-24'>
                            <div
                                className='blinking-text font-size-32 font-bold-700 font-color-3 mb-24 text-center'>Thank
                                you for submitting the response. Stay tuned for the insights.
                            </div>
                            <Lottie className='fadeIn-up' options={defaultOptionsSuccess} width={'100%'} height='50%'/>
                            <button onClick={handleCloseQuestionModal} className='quiz-button-2 mt-24 fadeIn-up'
                                    style={{
                                        color: data.hdrBtnFontColor,
                                        background: data.btnColor,
                                        borderColor: data.btnColor
                                    }}>
                                {closeText}
                            </button>
                        </div>
                    ) : (
                        <div className='p-24'>
                            {isAdmin ? (
                                <>
                                    <div className='flex fd-row items-center jc-space-between mb-8'>
                                        <h3 className='font-size-20 font-bold-700 font-color-2'>View Question</h3>
                                        <Button type='link' size='medium' danger ghost
                                                onClick={handleCloseQuestionModal}
                                                className='flex fd-row items-center font-size-16'>
                                            <AiOutlineClose className='mr-4'/>
                                            Close
                                        </Button>
                                    </div>
                                    <div className='mb-16 flex jc-space-between width-full'>
                                        <div type='primary' size='large' onClick={sendOutQuestion}
                                             className='button-gradient font-bold-600 flex-grow-1 jc-center flex items-center pt-6 pb-6 rounded-12 font-color-white cursor-pointer'
                                             style={{border: 'none'}}>
                                            <AiFillPushpin className='mr-8'/> Push To All Users
                                        </div>
                                    </div>
                                    <div className='mb-14 mt-24'>
                                        <hr className='border-color-10'
                                            style={{marginRight: '-24px', marginLeft: '-24px'}}/>
                                    </div>
                                    {showingResult ? (
                                        <div className='font-size-14 font-color-red font-bold-500 mb-16 mt-12 block'>
                                            <i>Note : Please close and reopen to see the updated result.</i>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </>
                            ) : (
                                ''
                            )}
                            <div className='flex items-center mb-16 fadeIn-up'>
                                <div className='font-size-22 font-bold-600'
                                     dangerouslySetInnerHTML={{__html: questionData.name}}/>
                            </div>
                            {questionData.contentUrl ? (
                                isVideo(questionData.contentUrl) ? (
                                    <ReactPlayer
                                        className='rounded-8 fadeIn-up'
                                        url={questionData.contentUrl}
                                        config={{file: {attributes: {controlsList: 'nodownload'}}}}
                                        width='100%'
                                        height='100%'
                                        playsinline={true}
                                        controls={true}
                                        style={{animationDelay: `0.15s`}}
                                    />
                                ) : (
                                    <Image src={questionData.contentUrl}
                                           className='width-full height-full obj-fit-cover rounded-8 fadeIn-up'
                                           alt={`Question : ${questionData.displayOrder}`}
                                           style={{animationDelay: `0.45s`}}/>
                                )
                            ) : (
                                ''
                            )}

                            <div className={`fadeIn-up ${questionData.contentUrl ? 'mt-24' : ''}`}
                                 style={{animationDelay: `0.30s`}}>
                                <ConfigProvider
                                    theme={{
                                        token: {
                                            colorPrimary: '#000',
                                        },
                                    }}
                                >
                                    {questionData.responseType == MCQ || (questionData.responseType == OPINIONATED) == SINGLE_SELECT
                                        ? questionData.questionType == MULTI_SELECT
                                            ? multiSelectResponseOption()
                                            : singleResponseOption()
                                        : questionData.responseType == SLIDER
                                            ? sliderResponse()
                                            : questionData.responseType == LIKE_DISLIKE
                                                ? likeDislikeResponse()
                                                : questionData.responseType == STAR
                                                    ? ratingResponse()
                                                    : questionData.responseType == SMILEY
                                                        ? smileyResponse()
                                                        : textResponse()}
                                </ConfigProvider>
                            </div>
                            {isAdmin ? (
                                ''
                            ) : (
                                <button
                                    onClick={() => {
                                        showingResult ? handleCloseQuestionModal() : handleSubmitResponse()
                                    }}
                                    className='quiz-button-2 mt-24 fadeIn-up'
                                    style={{
                                        color: data.hdrBtnFontColor,
                                        background: data.btnColor,
                                        borderColor: data.btnColor,
                                        animationDelay: `0.45s`
                                    }}
                                >
                                    {closeText}
                                </button>
                            )}
                        </div>
                    )}
                </div>
                {questionData ? <AdvertisementModerator advData={questionData.advertisement} data={data}
                                                        updateAdClickToSocket={(payload) => (isAdmin ? {} : updateAdClickToSocket(payload))}
                                                        updateAdViewToSocket={(payload) => (isAdmin ? {} : updateAdViewToSocket(payload))}/> : ''}
            </div>
        </DrawerBox>
    )
}

export default ModeratorQuestionDrawer
